/*
 * MDB shim for MDBSelect
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 */

import MUIMenuItem from "@mui/material/MenuItem";
import MUISelect from "@mui/material/Select";

export default function MDBSelect({
  children,
  options = [],
  selected,
  getValue,
  multiple,
  value,
  onChange,
  label,
  ...rest
}) {
  let resolvedValue = value ?? selected ?? (multiple ? [] : "");
  if (multiple && typeof resolvedValue === "string") {
    resolvedValue = [resolvedValue];
  }

  function handleChange(event) {
    onChange?.(event);
    getValue?.(event.target.value);
  }

  const renderedOptions = options.map((option, index) => {
    const optionValue = option.value ?? option.key ?? option.text ?? index;
    const optionLabel = option.text ?? option.label ?? optionValue;
    return (
      <MUIMenuItem key={optionValue} value={optionValue}>
        {optionLabel}
      </MUIMenuItem>
    );
  });

  return (
    <MUISelect
      multiple={multiple}
      value={resolvedValue}
      onChange={handleChange}
      color={rest.color ?? "primary"}
      displayEmpty={Boolean(label)}
      renderValue={(selectedValue) => {
        const isEmpty = multiple
          ? !selectedValue || selectedValue.length === 0
          : selectedValue === "" || selectedValue == null;

        if (isEmpty && label) {
          return label;
        }

        const values = Array.isArray(selectedValue)
          ? selectedValue
          : [selectedValue];

        return values
          .map((v) => {
            const match = options.find(
              (o, i) => (o.value ?? o.key ?? o.text ?? i) == v,
            );
            return match ? (match.text ?? match.label ?? v) : v;
          })
          .join(", ");
      }}
      {...rest}
    >
      {children || renderedOptions}
    </MUISelect>
  );
}
